module.exports = __webpack_public_path__ + "img/canada-diabetes-mellitus-female.6195c896.png";